export interface ForwardReferralFormDto {
  providerId?: string;
}

export const createForwardReferralFormDto = (
  providerId?: string
): ForwardReferralFormDto => {
  return { providerId: providerId || "" };
};
